const config = {
  DOMAIN: process.env.DOMAIN || "",
  API_DOMAIN: process.env.API_DOMAIN || "",
  GTM_ID: process.env.GTM_ID || "",
};
export default config;
